import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers';
import { Role } from './_models/users/Role';
import { OauthCallbackComponent } from './modules/auth/oauth-callback/oauth-callback.component';


const routes: Routes = [
   
   { path: 'oauth/callback', component: OauthCallbackComponent },

   { path: 'prospect', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
   {
      path: 'app',
      loadChildren: () => import('./modules/pages/pages.module').then(m => m.PagesModule),
      canActivate: [AuthGuard],
      data: { roles: [Role.Admin] }
   },
   {
      path: 'client',
      loadChildren: () => import('./modules/clients/clients.module').then(m => m.ClientsModule),
      canActivate: [AuthGuard]
   },
   {
      path: 'selling-help',
      loadChildren: () => import('./modules/selling-help/selling-help.module').then(m => m.SellingHelpModule),
      canActivate: [AuthGuard]
   },
   { path: '**', redirectTo: 'app', pathMatch: 'full' }

];

@NgModule({
   imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', onSameUrlNavigation: 'ignore' })],
   exports: [RouterModule]
})
export class AppRoutingModule {
}
